import React, { Component } from 'react';
import {
  Link
} from 'react-router-dom';

import Site, {SiteModifier_} from '../utils/Site'
import Each from '../utils/Each'

import Base from '../components/BaseComponent'
import Intro from '../components/Intro'
import Item from '../components/Item'
import Content from '../components/Content'
import Grid from '../components/Grid'
import Media from '../components/Media'
import Newsletter from '../components/Newsletter'
import Button from '../components/Button'
import Image from '../components/Image'
import Filters from '../components/Filters'
import EventsList from '../components/EventsList'
import FadeIn from '../components/FadeIn'
import ContentBlocks from '../components/ContentBlocks'
import MiniMap from '../components/MiniMap'
import CallToAction from '../components/CallToAction'
import ScrollTo from '../components/ScrollTo'
import Sponsors from '../components/Sponsors'
import Related from '../components/Related'
import ActionLogger from '../components/ActionLogger';

import moment from 'moment';


import Asset from '../models/Asset'
import Entry from '../models/Entry'



class Event extends Component {

	constructor(props) {
		super(props);
	}

	componentDidMount() {

	}

	componentWillUnmount() {

	}

	getDate = (dateStr) => {
	    return moment(dateStr).format('dddd MM.DD');
	  }

	  getTime = (dateStr) => {
	    return moment(dateStr).format('h.mma');
	  }

	 getSponsors = (item) => {
	 	if(item.sponsors.length) {
	 	return (<div className="Template-sponsors-container">
	 				<Content><h4>In association with:</h4></Content>
	 				<Sponsors item={item} itemClass="Template-sponsor" />
	 			</div>)
		 } else {
		 	return null
		 }
	 }

	 getTicketInfo = (item) => {
	 	if(!item.ticketInfo) return null

	 		let title = item.ticketInfoTitle ? item.ticketInfoTitle : 'Ticket Info'

	 		return (
	 	<div className="Template-section Template-section--narrow">
								<div className="Template-heading">
									<Content html={'<h1>'+title+'</h1>'}/>
								</div>
								<div className="Template-content">
									<Content html={item.ticketInfo}/>
								</div>
							</div>)
	 }
	/*

		RENDER

	*/

	render() {

		const {entry} = this.props;
		//console.log(entry)

		return (<FadeIn>

			<ScrollTo pos={0}/>
			<div className="Template  Template--default Template--event">

					{/* Template-head */}
					<div className="Template-head">

						<div className="Template-intro Template-intro--short">
							<Item modifiers={['intro']}>
								<div className="Item-media">
									<Media id={entry.image[0]} />
								</div>
								<div className="Item-head">
									<div className="Item-title">
										<Content modifier={'yellow'} html={'<h1>'+entry.title+'</h1>'}>
											
										</Content>
									</div>
									<div className="Item-subTitle">
										<Content>
											<h4>{entry.eventCategory}</h4>
										</Content>
									</div>
								</div>
							</Item>
						</div>

					</div>
					{/* / Template-head */}

					<div className="Template-button">
						<ActionLogger category={'Event'} action="Call to action click" label={entry.title + ': '+entry.callToActionTitle}>
							<CallToAction location={entry} />
						</ActionLogger>
					</div>


					{/* Template-body */}
					<div className="Template-body">

						<div className="Template-sections">
							<div className="Template-section Template-section--narrow">
								<div className="Template-heading">

										<Entry id={[entry.location[0]]} render={
											(loc) => (
										<Content modifier={'event'}><h2>{loc.title}</h2>
										<h3>{this.getDate(entry.startDate.date)}</h3>
										<h3 className="Event-time">{this.getTime(entry.startTime.date)}</h3></Content>
											)
										}/>

								</div>
								<div className="Template-content">
									<Content html={entry.description}/>

									<div className="Template-content-container  Template-content-container--sponsors">
										{this.getSponsors(entry)}
									</div>
								</div>
							</div>
							<div className="Template-section Template-section--narrow">
								<div className="Template-heading">
									<Content>
										<h1>Getting there</h1>
									</Content>
								</div>
								<div className="Template-content">
									<Content html={entry.gettingThere}/>

									<Entry id={[entry.location[0]]} render={
											(loc) => (

											<div data-lat={loc.latitude}>

											<MiniMap lat={loc.latitude} lng={loc.longitude} />

											</div>

											)
										}/>
								</div>
							</div>
							{this.getTicketInfo(entry)}

							

						<Related to={entry} />
						</div>


					</div>
					{/* / Template-body */}


			</div>
			</FadeIn>

		);

	}
}

export default Event;



// WEBPACK FOOTER //
// ./src/js/templates/Event.js